export default __webpack_public_path__ + "static/CircularStd-Book-482742800a2eefeb50668c8943204304.ttf";